import type AudioPlayer from '../audioplayer';

let audioPlayer: AudioPlayer | null = null;

export function initAudioPlayerShowUiImplementation(audioPlayerParam: AudioPlayer) {
  audioPlayer = audioPlayerParam;
}

export async function runAudioPlayerShowUiImplementation() {
  audioPlayer?.show();
}
